import Container from 'components/ui/Container';
import TextInput from 'components/ui/TextInput';
import { useFormik } from 'formik';
import getDoaminName from 'lib/getDomainName';
import { backendURL } from 'redux/reducers/settings';
import { useGetAppConfigByDomain, useUpdateAppConfig } from 'service/admin.query';
import { ActionType } from 'utils/action.type.enum';
import * as Yup from 'yup';

const AppConfigurationPage = () => {
  const domainname = getDoaminName();

  const { data: configData, isLoading, refetch } = useGetAppConfigByDomain(domainname);

  //   const updateMutation = useUpdateAppConfig(configData?.id || 1);
  const { mutate: updateMutation, isLoading: isUpdating } = useUpdateAppConfig();

  // 3. Formik Setup
  const formik = useFormik({
    enableReinitialize: true, // Important: updates form when API data loads
    initialValues: {
      id: configData?.id,
      title: configData?.title || '',
      domain_name: configData?.domain_name || '',
      address: configData?.address || '',
      phone_number: configData?.phone_number || '',
      logo: configData?.logo ?? null,
      background_image: configData?.background_image ?? null,
      register_image: configData?.register_image ?? null,
      login_image: configData?.login_image ?? null
    },
    validationSchema: Yup.object({
      title: Yup.string().required('Required'),
      domain_name: Yup.string().required('Required')
    }),
    onSubmit: (values) => {
      updateMutation(values, {
        onSuccess: (res) => {
          if (res?.data.code == 200) {
            refetch();
            // toast.success(res?.data.message ?? 'Update successfully');
          } else {
            // toast.error(res?.data.message ?? 'Failed');
          }
        },
        onError: (err) => {
          //   toast.error(err.message ?? 'Failed');
        }
      });
    }
  });

  if (isLoading) return <div>Loading Configuration...</div>;

  return (
    <Container title="App Configuration" module_code="AP" actionType={ActionType.CAN_VIEW}>
      <div className="container-fluid p-4">
        <div className="card">
          <div className="card-header">
            <h5>Update App Configuration</h5>
          </div>
          <div className="card-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                {/* Text Inputs */}
                <TextInput
                  label="App Title"
                  name="title"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.title}
                  onBlur={formik.handleBlur}
                  formik={formik}
                  containerClassName="col-md-6 mb-3"
                />

                <TextInput
                  label="Domain Name"
                  name="domain_name"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.domain_name}
                  onBlur={formik.handleBlur}
                  disabled
                  formik={formik}
                  containerClassName="col-md-6 mb-3"
                />

                <TextInput
                  label="Address"
                  name="address"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.address}
                  onBlur={formik.handleBlur}
                  formik={formik}
                  containerClassName="col-md-6 mb-3"
                />

                <TextInput
                  label="Phone Number"
                  name="phone_number"
                  type="text"
                  onChange={formik.handleChange}
                  value={formik.values.phone_number}
                  onBlur={formik.handleBlur}
                  formik={formik}
                  containerClassName="col-md-6 mb-3"
                />

                {/* File Inputs */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Logo</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => formik.setFieldValue('logo', e.target.files?.[0])}
                  />

                  <img
                    src={backendURL + configData?.logo}
                    alt=""
                    style={{ height: 100, borderRadius: '50%' }}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Background Image</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => formik.setFieldValue('background_image', e.target.files?.[0])}
                  />

                  <img
                    src={backendURL + configData?.background_image}
                    alt=""
                    style={{ height: 100 }}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Login Image</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => formik.setFieldValue('login_image', e.target.files?.[0])}
                  />
                  <img src={backendURL + configData?.login_image} alt="" style={{ height: 100 }} />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Register Image</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => formik.setFieldValue('register_image', e.target.files?.[0])}
                  />
                  <img
                    src={backendURL + configData?.register_image}
                    alt=""
                    style={{ height: 100 }}
                  />
                </div>
              </div>

              <div className="mt-4">
                <button type="submit" className="btn btn-primary" disabled={isUpdating}>
                  {isUpdating ? 'Updating...' : 'Update Configuration'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AppConfigurationPage;
